/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiLabelingConfig
 */
export interface AiLabelingConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AiLabelingConfig
     */
    enabled: boolean;
}

export function AiLabelingConfigFromJSON(json: any): AiLabelingConfig {
    return AiLabelingConfigFromJSONTyped(json, false);
}

export function AiLabelingConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiLabelingConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function AiLabelingConfigToJSON(value?: AiLabelingConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

